
import React, {useState} from 'react';
import VisDiv from '../frontend_components/VisDiv';
import { v4 as uuidv4 } from 'uuid';
import { keyId, sortByLabel, positionNumber  } from '../../lib/utils'; 
import {FiSave } from 'react-icons/fi'
import FieldDropdown from '../FieldDropdown';
import TextField from '../TextField';

export const InsertProduct = ({saveFn, data={}}) => {

    const {register, existingProducts, returnData, siteRegisters} = data
    //console.log("empty doc generated data",emptyDocGeneratedData)
    const [selectedRegister, setSelectedRegister] = useState(register)
    const [positions, setPositions] = useState([])  
    const firstProduct = existingProducts?.[0]
    //const [customerProducts, setCustomerProducts] = useState([])  
  
  
    const testFunction = (e) => {
      e?.stopPropagation();
      console.log("EXISTING DEVICES", selectedRegister, existingProducts, "FIRST PRODUCT", firstProduct)
    }
    const newDocs = positions?.map?.((doc)=>{
      const newDoc = {
        ...firstProduct,
        quantity: doc?.unit ? doc?.unit : "1",
        unit: doc?.unit,
        _id: doc?._id,
        _key: doc?._key,
        hide: false,
        addedLocation: true,
        deviceNonConformityId: undefined,
        nonConformityId: undefined,
        nonConformity: "",
        location: ` ${doc?.value}`,
        deviceId: doc?.deviceId,
      }
      return newDoc
    })
  
    const addProducts = (e) => {
      e?.stopPropagation();
  
      //console.log("FIRST PRODUCT", firstProduct)
      saveFn(newDocs)
      setPositions([])
    }
  
    const positionsFilter = (device) => {
      const devicesWithOfferProperty = !Array.isArray(selectedRegister?.devices) ? [] : selectedRegister?.devices?.filter?.((dev)=>dev?.fields?.some?.((x)=>x?.values?.some?.((t)=>t?._id == firstProduct?.offerPropertyId)))
      //if(devicesWithOfferProperty?.length > 0) console.log("FOUND nerjfnerjf", devicesWithOfferProperty)
      if(firstProduct?.offerPropertyId) return devicesWithOfferProperty?.some?.((z)=>z?._id == device?._id) && device?.templateDevice?._ref == firstProduct?.deviceFamilyId && device?.status !== "ARCHIVIATO" && !existingProducts?.some?.(y=>y?.deviceId == device?._id)   
      if(firstProduct?.deviceFamilyId) return device?.templateDevice?._ref == firstProduct?.deviceFamilyId && device?.status !== "ARCHIVIATO" && !existingProducts?.some?.(y=>y?.deviceId == device?._id)
      return device?.status !== "ARCHIVIATO" && !existingProducts?.some?.(y=>y?.deviceId == device?._id)
      
    }
  
    const positionsList = !Array.isArray(selectedRegister?.devices) ? [] : selectedRegister?.devices?.filter?.(positionsFilter)?.map?.((device)=>{
      const position = positionNumber(device)
      const doc = {
        _id: uuidv4(),
        _key: keyId(),
        unit: firstProduct?.unit, 
        deviceId: device?._id,
        label: position,
        value: position,
        device
      }
      return doc
    })
  
    const labelAndName = (label="", name="") => {
        return `${label} ${name}`
    }
  const returnStatement = () => {
    return (
      <>
      <VisDiv rules={[siteRegisters?.length>0]}>
        <FieldDropdown
                isSearchable="isSearchable"
                initialValue={{...selectedRegister, value: labelAndName(selectedRegister?.label,selectedRegister?.name), label: labelAndName(selectedRegister?.label,selectedRegister?.name)}}
                placeHolder={"SELEZIONA REGISTRO"}
                options={siteRegisters?.map?.((register)=>({...register, value: labelAndName(register?.label, register?.name), label: labelAndName(register?.label, register?.name)}))?.sort(sortByLabel)}
                onChange={(value) => {
                  //console.log("SELECTED LOADED PRODUCT", customerProduct) 
                  setSelectedRegister(value)
                }
                }
            />
      </VisDiv>
      <VisDiv rules={[positionsList?.length > 0 ]}>
          {/* <button onClick={(e)=>{testFunction(e)}}>test add to list</button> */}
          <div style={{display:"flex", alignItems:"center"}}>
              <div style={{minWidth:"30%"}}>
                <FieldDropdown
                  isMulti={true}
                  isSearchable="isSearchable"
                  initialValue={positions}
                  placeHolder={"AGGIUNGI POSIZIONI"}
                  options={positionsList?.sort(sortByLabel)}
                  onChange={(value) => {
                    //console.log("SELECTED LOADED PRODUCT", customerProduct) 
                    setPositions(value)
                  }
                  }
                />
              </div>
    
                <VisDiv rules={[!returnData]} type='button' className='round-back-button' style={{backgroundColor:"green", marginLeft:"10px"}} onClick={addProducts}>
                  <FiSave            
                      size={15}
                      color={"white"}
                    />
                </VisDiv>
          </div>
              <VisDiv rules={[positions?.length>0]}>
                {positions?.sort(sortByLabel)?.map?.((position)=>{
                    const onClickRow = (e)=> {
                      e?.stopPropagation()
                      console.log("ROW CLICKED", position)
                    }
                    return(
                      <VisDiv rules={[true]} key={position?._id} onClick={(e)=>onClickRow(e)} style={{display:"flex", alignItems:"center"}}>
                        <p style={{padding:"2px"}} >{`Posizione: ${position?.label}`}</p>
                        <p style={{padding:"2px"}} >{` | Unità: `}</p>
                        <TextField 
                            //onBlur={()=> setDoc({...unitDoc, unit: Number(unitDoc?.unit)})}
                            value={position?.unit} 
                            onChange={(e) => setPositions([...!Array.isArray(positions) ? [] : positions?.filter?.((x)=>x?._id !== position?._id), {...position, unit: e.target.value}])} 
                            //label={"UNITA'"}
                            type={"text"}
                            //description={"Inserire il numero di unità. Per esempio se deve uscire più di una volta, come nel caso dei cartelli nelle porte/uscite a doppia anta o nel numero dei Kg per lo smaltimento degli estintori"} 
                        />
                        <VisDiv rules={[position?.device?.nonConformities?.length > 0, false]}>
    {/*                       <FieldDropdown
                            isMulti={false}
                            isSearchable="isSearchable"
                            //initialValue={client}
                            placeHolder={"ASSEGNA A NON CONFORMITA"}
                            options={positionsList?.sort(sortByLabel)}
                            onChange={(value) => {
                              //console.log("SELECTED LOADED PRODUCT", customerProduct) 
                              //setPositions(value)
                            }
                          }  /> */}
                        </VisDiv>
                      </VisDiv>
                    )
                  })
                }
    
              </VisDiv>
    
      </VisDiv>
      </>
    )
  }
  
    if (returnData) return ({returnStatement: returnStatement(), data: newDocs})
    return returnStatement()
  }
  